/* eslint-disable */
import ctype from 'component-type';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the type of a given `label` is invalid
 * @export
 * @class I18nInvalidLabelTypeError
 * @extends {Error}
 */
export class I18nInvalidLabelTypeError extends Error {
  /**
   * Creates an instance of I18nInvalidLabelTypeError
   * @param {string} message The Error `message`
   * @memberof I18nInvalidLabelTypeError
   */
  constructor(message) {
    super(message);
    this.name = `I18nInvalidLabelTypeError`;
  }
}

/**
 * Called when the type of a given `label` is invalid
 * @param {any} label The invalid `label`
 * @returns {never} never
 */
const throwI18nInvalidLabelTypeError = (label) => {
  throw new I18nInvalidLabelTypeError(
    stripIndent(`
    Expected "label" to be of type String.
    Got: "${ctype(label)}".
    `),
  );
};

export default throwI18nInvalidLabelTypeError;
